window.Workarea = function () {
    var el = this;

    el.workAreaScale = 1;
    
    el.templateData = {};
    el.workareas = {};
    el.workarea_formats = {};

    function getViewArea() {
        var workarea = el.workData.workareas[el.selectWorkareaId];
        var $el = $('#hardcover-wrapper');

        var pos = {
            width: $el.width(),
            height: $el.width() / workarea.width * workarea.height
        };

        var availHeight = $(window).height();
        $('#page-step-constructor .navbar').each(function () {
            availHeight -= $(this).outerHeight();
        });

        availHeight -= $('.top-panel').outerHeight();
        availHeight = availHeight - $('.book').outerHeight() + $('.book').height();

        if (pos.height > availHeight && pos.width >= 768) {
            pos.height = availHeight;
            pos.width = parseInt(pos.height / workarea.height * workarea.width);
        }

        if (pos.width < 0) {
            pos.width = '100%';
        }

        if (pos.height < 0) {
            pos.height = '100%';
        }

        return pos;
    }

    el.init = function (template, firstInit) {
        var productId = el.product.id;
        var workareas = el.workareas[productId];
        var showDate = false;
        var oldData = $.extend(true, {}, el._parent.workData);
        
        el.calendarGrid.init();

        el._parent.workData = {
            color_id: el.color.current.id,
            size_id: el.size.current.id,
            language: el.language.current,
            workareas: {}
        };

        el._parent.selectWorkareaId = 0;

        var templateWorkareaIndex = 0, templateFormat, templateWorkarea, workareaId, formatId, workarea, format;
        for (workareaId in workareas) {
            workarea = workareas[workareaId];

            if (el.selectWorkareaId === 0) {
                el._parent.selectWorkareaId = workareaId;
            }

            if (!el.workarea_formats.hasOwnProperty(workareaId)) {
                console.log('Не указан формат для рабочей области');
            }

            if (el.workarea_formats[workareaId].hasOwnProperty(el.format.current.id)) {
                formatId = el.format.current.id;
            } else {
                var price = el.calculator.price[el.calculator.priceGroupId][el.product.id];

                for (var i in price) {
                    if (i === '0') {
                        continue;
                    }

                    if (el.workarea_formats[workareaId].hasOwnProperty(i)) {
                        formatId = i;
                        break;
                    }
                }
            }

            format = el.workarea_formats[workareaId][formatId];
            templateWorkarea = template ? el.template.getWorkarea(template, templateWorkareaIndex) : false;
            templateFormat = templateWorkarea.format;

            el._parent.workData.workareas[workareaId] = {
                id: workareaId,
                width: el.WORKAREA_WIDTH,
                height: workarea.height,
                name: el.workareas[productId][workareaId].name,
                type: template && templateWorkarea && templateWorkarea.hasOwnProperty('type') ? templateWorkarea.type : '1',
                format: {
                    id: format.format_id,
                    x: format.x,
                    y: format.y,
                    width: format.width,
                    height: format.height,
                    cells: template && templateFormat && templateFormat.hasOwnProperty('cells') ? templateFormat.cells : {},
                    images: template && templateFormat && templateFormat.hasOwnProperty('images') ? templateFormat.images : {},
                    backgrounds: template && templateFormat && templateFormat.hasOwnProperty('backgrounds') ? templateFormat.backgrounds : {},
                    texts: template && templateFormat && templateFormat.hasOwnProperty('texts') ? templateFormat.texts : {},
                    decors: template && templateFormat && templateFormat.hasOwnProperty('decors') ? templateFormat.decors : {},
                    layers: template && templateFormat && templateFormat.hasOwnProperty('layers') ? templateFormat.layers : {},
                    calendar_grids: template && templateFormat && templateFormat.hasOwnProperty('calendar_grids') ? templateFormat.calendar_grids : {}
                }
            };

            if (
                oldData.hasOwnProperty('workareas')
                && oldData.workareas.hasOwnProperty(workareaId)
                && oldData.workareas[workareaId].hasOwnProperty('format')
                && oldData.workareas[workareaId].format.hasOwnProperty('images')
            ) {
                var newImage;
                var format = el._parent.workData.workareas[workareaId].format
                var oldImages = oldData.workareas[workareaId].format.images;
                for (var cellId in format.cells) {
                    if (oldImages.hasOwnProperty(cellId) ) {
                        newImage = $.extend(true, {}, oldImages[cellId]);

                        if (
                            format.images.hasOwnProperty(cellId)
                            && format.images[cellId].hasOwnProperty('mask')
                            && format.images[cellId].hasOwnProperty('company_id')
                        ) {
                            newImage.mask = format.images[cellId].mask;
                            newImage.company_id = format.images[cellId].company_id;
                        } else {
                            if (
                                newImage.hasOwnProperty('mask')
                                && newImage.hasOwnProperty('company_id')
                            ) {
                                delete(newImage.mask);
                                delete(newImage.company_id);
                            }
                        }

                        format.images[cellId] = newImage;
                        el.upImages.reinitImagePosition(workareaId, 'cell', cellId);
                        el.upImages.setUsedImage(oldImages[cellId].name);
                    }
                }
            }
            
            if (template && templateFormat && templateFormat.hasOwnProperty('calendar_grids') && Object.keys(templateFormat.calendar_grids).length > 0) {
                showDate = true;
            }

            templateWorkareaIndex++;
        }
        
        if (showDate && firstInit && parseInt(el.description.show_calendar_date) === 1) {
            el.calendarGrid.updateDate();
            el.calendarGrid.showDate();
        }
    };

    el.initTemplate = function () {
        el._parent.workData = {
            workareas: {}
        };

        /** id и name числовые, но формат всегда строковый */
        el._parent.selectWorkareaId = '1';

        var format = el.format.current;
        var height = parseInt(el.WORKAREA_WIDTH * format.height / format.width);


        el._parent.workData.workareas[el.selectWorkareaId] = {
            id: el.selectWorkareaId,
            width: el.WORKAREA_WIDTH,
            height: height,
            name: el.selectWorkareaId,
            type: '1',
            format: {
                id: format.id,
                x: 0,
                y: 0,
                width: el.WORKAREA_WIDTH,
                height: height,
                cells: {},
                images: {},
                backgrounds: {},
                texts: {},
                decors: {},
                layers: {},
                calendar_grids: {}
            }
        };
    };

    el.setFormat = function (formatId) {
        var i, format;
        for (i in el.workarea_formats[el.selectWorkareaId]) {
            format = el.workarea_formats[el.selectWorkareaId][i];
            if (format.format_id === formatId) {
                break;
            }
        }

        el._parent.workData.workareas[el.selectWorkareaId].format = {
            id: format.format_id,
            x: format.x,
            y: format.y,
            width: format.width,
            height: format.height,
            cells: {},
            images: {},
            backgrounds: {},
            texts: {},
            decors: {},
            layers: {}
        };
    };

    el.rotateFormat = function () {
        var oldFormat = el.workData.workareas[el.selectWorkareaId].format;
        var center = {
            x: parseInt(oldFormat.x) + parseInt(oldFormat.width) / 2,
            y: parseInt(oldFormat.y) + parseInt(oldFormat.height) / 2
        };

        el._parent.workData.workareas[el.selectWorkareaId].format = {
            id: oldFormat.id,
            x: parseInt(center.x - oldFormat.height / 2),
            y: parseInt(center.y - oldFormat.width / 2),
            width: parseInt(oldFormat.height),
            height: parseInt(oldFormat.width),
            cells: {},
            images: {},
            backgrounds: {},
            texts: {},
            decors: {},
            layers: {}
        };
    };

    el.add = function () {
        var ids = Object.keys(el.workData.workareas);
        var workareaId = String(parseInt(ids[ids.length - 1]) + 1);
        var format = el.format.current;
        var height = parseInt(el.WORKAREA_WIDTH * format.height / format.width);

        el._parent.workData.workareas[workareaId] = {
            id: workareaId,
            width: el.WORKAREA_WIDTH,
            height: height,
            name: workareaId,
            type: '1',
            format: {
                id: format.id,
                x: 0,
                y: 0,
                width: el.WORKAREA_WIDTH,
                height: height,
                cells: {},
                images: {},
                backgrounds: {},
                texts: {},
                decors: {},
                layers: {},
                calendar_grids: {}
            }
        };

        el.render();
        el.preview.render();
    };

    el.copy = function (id) {
        var workarea = $.extend(true, {}, el._parent.workData.workareas[id]);

        var ids = Object.keys(el.workData.workareas);
        var workareaId = String(parseInt(ids[ids.length - 1]) + 1);
        var format = el.format.current;
        var height = parseInt(el.WORKAREA_WIDTH * format.height / format.width);

        workarea.id = workareaId;
        workarea.name = workareaId;
        el._parent.workData.workareas[workareaId] = workarea;

        el.render();
        el.preview.render();
    };

    el.remove = function (id) {
        var ids = Object.keys(el.workData.workareas);
        
        if (ids.length <= 1) {
            el.dialog.show('message', {message: Yii.t('Can not delete last workspace')});
            return false;
        }

        delete(el._parent.workData.workareas[id]);

        var ids = Object.keys(el.workData.workareas);
        el._parent.selectWorkareaId = ids[0];

        el.render();
        el.preview.render();
    };

    el.render = function (partial) {
        if (el._parent.hasOwnProperty('product')) {
            var productId = el.product.id;
        }
        var workarea = el._parent.workData.workareas[el.selectWorkareaId];

        el.templateData = {
            partial: partial,
            product_id: productId,
            workarea_id: el.selectWorkareaId,
            width: workarea.width,
            height: workarea.height,
            sid: window.bookSid,
            color: el._parent.hasOwnProperty('color') ? el.color.current : {},
            mask: {
                id: productId && el.workareas[productId][el.selectWorkareaId].mask === '1' ? el.selectWorkareaId : 0
            },
            format: {}
        };
        
        if (productId) {
            var background = el.workareas[productId][el.selectWorkareaId].background;
            el.templateData.background = {
                is_show: background !== null,
                url: background
            };
        }

        var pos = getViewArea();
        el.templateData.mainheight = pos.height;
        el.templateData.mainwidth = pos.width;


        var templateFormat;
        var format = workarea.format;

        templateFormat = {
            id: format.id,
            width: format.width,
            height: format.height,
            view_width: el.WORKAREA_WIDTH,
            view_height: parseInt(el.WORKAREA_WIDTH * format.height / format.width),
            x: format.x,
            y: format.y
        };

        var formatData = el.format.items[format.id];
        var scale = formatData.width / el.MM_IN_PIXELS / el.WORKAREA_WIDTH;
        var safeAreaWidth = 0;
        if (el._parent.hasOwnProperty('description')) {
            safeAreaWidth = el.description.safe_area_width / el.MM_IN_PIXELS;
        }
        var newSafeAreaWidth = safeAreaWidth / scale;
        el.templateData.safeArea = {
            is_show: parseInt(safeAreaWidth) !== 0,
            x1: 0,
            y1: 0,
            width1: templateFormat.view_width,
            height1: templateFormat.view_height,
            x2: newSafeAreaWidth,
            y2: newSafeAreaWidth,
            width2: templateFormat.view_width - newSafeAreaWidth,
            height2: templateFormat.view_height - newSafeAreaWidth
        };

        // generated backgrounds, cells, texts
        templateFormat.backgrounds = [];
        var i;
        var images = $.extend(true, {}, format.backgrounds);
        var image;
        for (i in images) {
            if (images.hasOwnProperty(i) && images[i] !== null) {
                image = images[i];
                image.id = i;

                switch (image.type) {
                    case 'custom':
                        image.url = window.location.origin + el.projectsPath + '/' + window.bookSid + '/workimages/' + image.name;
                        break;
                    case 'theme':
                        image.url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/themes/' + image.company_id + '/' + image.theme_id + '/workimages/' + image.name;
                        break;
                    case 'template':
                        image.url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/templates/' + image.theme_id + '/workimages/' + image.name;
                        break;
                }
                templateFormat.backgrounds.push(image);
            }
        }

        templateFormat.layers = el.layer.getTemplateLayers(el.selectWorkareaId, 'workimages');
        templateFormat.texts = [];
        var i, j, rows, text;
        for (i in format.texts) {
            text = $.extend(true, {}, format.texts[i]);
            rows = $.extend(true, {}, text.rows);
            text.rows = [];
            
            for (j in rows) {
                text.rows.push(rows[j]);
            }

            templateFormat.texts.push(text);
        }

        //calendar_grids
        templateFormat.calendar_grids = [];
        var i, item, content;
        if (format.hasOwnProperty('calendar_grids')) {

            for (i in format.calendar_grids) {
                item = format.calendar_grids[i];

                content = el.calendarGrid.render(item, item.year.name, item.month.number, i, true);

                templateFormat.calendar_grids.push({
                    is_selection: el._parent.hasOwnProperty('isTemplater') ? true : false,
                    id: i,
                    x: item.x,
                    y: item.y,
                    width: item.width,
                    height: item.height,
                    mainwidth: item.mainwidth,
                    mainheight: item.mainheight,
                    rotate_angle: item.rotate_angle,
                    rotate_x: item.rotate_x,
                    rotate_y: item.rotate_y,
                    content: content
                });
            }
        }

        el.templateData.format = templateFormat;

        var output = window.Mustache.render($('#constructor-hardcover-template').html(), el.templateData);
        $('#hardcover-wrapper').html(output);

        var $el = $('#constructor-hardcover');
        el.workAreaScale = $el.width() / el.workData.workareas[el.selectWorkareaId].width;

        if (el._parent.hasOwnProperty('calculator')) {
            el.calculator.calcCost();
        }
        
        $('.js-workarea-type-set').val(workarea.type);
    };

    el.set = function (id) {
        el._parent.selectWorkareaId = id;

        if (!el._parent.hasOwnProperty('isTemplater')) {
            el.format.current = el.format.items[el.workData.workareas[id].format.id];
            el.format.render();
        }

        el.selection.hide();
        el.preview.set(id);
    };

    el.isExistData = function (id) {
        if (!el.workData.hasOwnProperty('workareas')) {
            return false;
        }
        
        if (!el.workData.workareas.hasOwnProperty(id)) {
            return false;
        }
        
        if (!el.workData.workareas[id].hasOwnProperty('format')) {
            return false;
        }
        
        var format = el.workData.workareas[id].format;

        if (Object.keys(format.layers).length > 0) {
            return true;
        }

        if (Object.keys(format.backgrounds).length > 0) {
            return true;
        }

        if (Object.keys(format.texts).length > 0) {
            return true;
        }
        
        if (format.hasOwnProperty('calendar_grids') && Object.keys(format.calendar_grids).length > 0) {
            return true;
        }

        return false;
    };
    
    el.setType = function(id) {
        el._parent.workData.workareas[el.selectWorkareaId].type = id;
    };
    
    $(document).on('click', '.js-set-workarea', function () {
        el.set($(this).attr('data-id'));
    });

    $(document).on('click', '.js-workarea-add', function () {
        el.add();
    });

    $(document).on('click', '.js-workarea-copy', function () {
        el.copy(el.selectWorkareaId);
    });

    $(document).on('click', '.js-workarea-remove', function () {
        el.remove(el.selectWorkareaId);
    });
    
    $(document).on('click', '.js-workarea-type-set', function () {
        el.setType($(this).val());
    });
};